.menu {
  display: flex;
  flex-direction: column;
  width: 16rem;
}
